import React from 'react';
import {Row, Col, Typography} from 'antd';
import WizardForm from '../components/WizardForm';
import {regoSteps, Location} from '../Constants';
import {myAuth} from '../elements/PrivateRoute/PrivateRoute';
import PageLink from '../elements/PageLink/PageLink';
import LoginFooter from '../components/LoginFooter';
import CellnetLogo from '../elements/Logo/Logo';
import HomeBg from '../components/HomeBg';
import { pageVariants } from '../Constants';
import { motion } from "framer-motion";
import { Redirect, useLocation  } from 'react-router-dom';
import { getPrevProp } from '../utils';

const { Title } = Typography;

function Register() {

  let location = useLocation<Location>();
  let prevProp = getPrevProp(location.state)

  // stop user from accessing login page again
  if (myAuth.isAuthenticated) {
    return (
        <Redirect
            to={{
                pathname: prevProp
            }}
        />
    )
  }

  return (
    <Row justify='center' align='middle' className='fullHeight overflowHidden'>
        <HomeBg isRego/>
        <Col xs={24} sm={24} md={8} lg={8} xl={13} className='overflowHidden padding30px fullHeight verticalCenter flexColumn whiteBg'>
          <motion.div className='marginTopAuto' initial='initial' animate="in" exit="out" variants={pageVariants}>
            <CellnetLogo to='/' className="textCenter marginBottom40px"/>
            <Title level={5} className='textCenter marginBottom25px'>Sign up to Cellnet</Title>
            <div className='textCenter marginTop25px'>
                <div className='textCenter marginTop25px'>
                    <PageLink to="/cash-application" bold className='marginLeft10px'>Sign up as a cash customer here</PageLink><br/>
                </div>
                <div className='textCenter marginTop25px'>
                  <PageLink to="/credit-application" bold className='marginLeft10px'>Sign up as a credit customer here</PageLink><br/>
                </div>
                <div className='textCenter marginTop25px'>
                  <PageLink to="/cash-to-credit-application" bold className='marginLeft10px'>Change from a cash customer to a credit customer here</PageLink><br/>
                </div>
                <div className='textCenter marginTop25px'>
                    <strong>Already a member?</strong>
                    <PageLink to="/" bold className='marginLeft10px text-secondaryColor'>Sign In</PageLink>
                </div>
            </div>
          </motion.div>
          <LoginFooter className='marginTopAuto'/>
        </Col>
    </Row>
  );
}

export default Register;
